/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FufiFinancialInfoPremiumFrequency = {
    HalfYearly: 'HalfYearly',
    Monthly: 'Monthly',
    OneTime: 'OneTime',
    Quarterly: 'Quarterly',
    Yearly: 'Yearly',
    Unknown: 'Unknown'
} as const;
export type FufiFinancialInfoPremiumFrequency = typeof FufiFinancialInfoPremiumFrequency[keyof typeof FufiFinancialInfoPremiumFrequency];


export function instanceOfFufiFinancialInfoPremiumFrequency(value: any): boolean {
    for (const key in FufiFinancialInfoPremiumFrequency) {
        if (Object.prototype.hasOwnProperty.call(FufiFinancialInfoPremiumFrequency, key)) {
            if (FufiFinancialInfoPremiumFrequency[key as keyof typeof FufiFinancialInfoPremiumFrequency] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FufiFinancialInfoPremiumFrequencyFromJSON(json: any): FufiFinancialInfoPremiumFrequency {
    return FufiFinancialInfoPremiumFrequencyFromJSONTyped(json, false);
}

export function FufiFinancialInfoPremiumFrequencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): FufiFinancialInfoPremiumFrequency {
    return json as FufiFinancialInfoPremiumFrequency;
}

export function FufiFinancialInfoPremiumFrequencyToJSON(value?: FufiFinancialInfoPremiumFrequency | null): any {
    return value as any;
}

export function FufiFinancialInfoPremiumFrequencyToJSONTyped(value: any, ignoreDiscriminator: boolean): FufiFinancialInfoPremiumFrequency {
    return value as FufiFinancialInfoPremiumFrequency;
}

